"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingValidationPrompt = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var axios_1 = __importDefault(require("axios"));
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var meter_photo_1 = require("../../../../shared/api/kapi/v1/operations/meter-photo");
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var copy_1 = require("../../copy");
var images_1 = require("../../images");
var utils_1 = require("../../pages/SubmitMeterReading/utils");
var utils_2 = require("../../utils");
var AddMeterPhoto_1 = require("../AddMeterPhoto/AddMeterPhoto");
var MeterReadingValidationPrompt_styled_1 = require("./MeterReadingValidationPrompt.styled");
function MeterReadingValidationPrompt(_a) {
    var _this = this;
    var _b;
    var accountId = _a.accountId, data = _a.data, apiError = _a.apiError, apiErrorData = _a.apiErrorData, latestActualReading = _a.latestActualReading, isInProgress = _a.isInProgress, isMultiRate = _a.isMultiRate, onSubmit = _a.onSubmit, onCancel = _a.onCancel, validationError = _a.validationError, fuel = _a.fuel, numOfDigits = _a.numOfDigits, onImgChange = _a.onImgChange;
    var previousReading = formatPreviousReading(latestActualReading);
    var reading = formatReading(data, isMultiRate);
    var _c = (0, core_1.useComponents)(), Stack = _c.Stack, Card = _c.Card, ErrorNotification = _c.ErrorNotification, Callout = _c.Callout, Heading2 = _c.Heading2, PrimaryCTAButton = _c.PrimaryCTAButton, SecondaryCTAButton = _c.SecondaryCTAButton, ButtonGroup = _c.ButtonGroup, SummaryList = _c.SummaryList, SummaryItem = _c.SummaryItem;
    var _d = __read((0, react_1.useState)(), 2), img = _d[0], setImage = _d[1];
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var dispatch = (0, ui_tools_1.useAnalytics)().dispatch;
    var _e = (0, utils_1.mapApiErrorCode)(validationError), message = _e.message, multiRateMessage = _e.multiRateMessage;
    var _f = __read((0, react_1.useState)(false), 2), isLoading = _f[0], setIsLoading = _f[1];
    var errorMessage = isMultiRate && multiRateMessage ? multiRateMessage : message;
    var handleImageChange = function (img) {
        setImage(img);
        onImgChange(img.name);
    };
    var _g = __read((0, meter_photo_1.useWriteMeterPhotoMutation)(), 1), mutate = _g[0];
    var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        var sprn, mimeType, readDate, contentLength, readValue;
        var _a;
        var _this = this;
        return __generator(this, function (_b) {
            setIsLoading(true);
            if (!img) {
                // meter photo not mandatory
                dispatch({
                    name: analytics_subjects_1.METER_PHOTO_NONE_SELECTED,
                    type: 'click',
                    properties: (_a = {},
                        _a[core_1.INTERNAL_EVENT_FLAG] = true,
                        _a),
                });
                onSubmit();
                setIsLoading(false);
                return [2 /*return*/];
            }
            sprn = data.mpxn;
            mimeType = img.type;
            readDate = (0, date_fns_1.format)(Date.now(), 'yyyy-MM-dd');
            contentLength = img.size;
            readValue = typeof reading === 'number' ? reading : reading.peak;
            mutate({
                variables: {
                    input: {
                        accountId: accountId,
                        sprn: sprn,
                        mimeType: mimeType,
                        readDate: readDate,
                        contentLength: contentLength,
                        readValue: String(readValue),
                    },
                },
                onCompleted: function (urlData) { return __awaiter(_this, void 0, void 0, function () {
                    var url, err_1;
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _c.trys.push([0, 2, 3, 4]);
                                url = new URL(urlData.writeMeterPhoto.uploadUrl).toString();
                                // don't use api-service because it adds headers S3 isn't expected
                                return [4 /*yield*/, axios_1.default.put(url, 
                                    // contentlength set automatically
                                    img)];
                            case 1:
                                // don't use api-service because it adds headers S3 isn't expected
                                _c.sent();
                                dispatch({
                                    name: analytics_subjects_1.METER_PHOTO_UPLOAD_SUCCESS,
                                    type: 'click',
                                    properties: (_a = {},
                                        _a[core_1.INTERNAL_EVENT_FLAG] = true,
                                        _a),
                                });
                                // setHasImgError(false);
                                onSubmit(false);
                                return [3 /*break*/, 4];
                            case 2:
                                err_1 = _c.sent();
                                // if meter photo fails, just log it and carry on
                                console.error('failed to upload', err_1);
                                dispatch({
                                    name: analytics_subjects_1.METER_PHOTO_UPLOAD_ERROR,
                                    type: 'click',
                                    properties: (_b = {
                                            error: err_1
                                        },
                                        _b[core_1.INTERNAL_EVENT_FLAG] = true,
                                        _b),
                                });
                                onSubmit(true);
                                return [3 /*break*/, 4];
                            case 3:
                                setIsLoading(false);
                                return [7 /*endfinally*/];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); },
                onError: function (err) {
                    var _a;
                    console.error("Failed to get photo upload url: ".concat(err));
                    dispatch({
                        name: analytics_subjects_1.METER_PHOTO_UPLOAD_ERROR,
                        type: 'click',
                        properties: (_a = {
                                error: err
                            },
                            _a[core_1.INTERNAL_EVENT_FLAG] = true,
                            _a),
                    });
                    setIsLoading(false);
                    // on writeMeterPhoto failure, continue read submission
                    onSubmit(true);
                },
            });
            return [2 /*return*/];
        });
    }); };
    return apiError ? (react_1.default.createElement(ErrorNotification, { id: "api-error-post-validation" },
        react_1.default.createElement(Copy, { copyKey: "apiError" }))) : (react_1.default.createElement(Card, { "data-testid": "validation-prompt" },
        react_1.default.createElement(Callout, { variant: "error", "data-testid": "error-summary-notification", id: "error-notification" },
            react_1.default.createElement(Heading2, { id: "error-notification-title" },
                (errorMessage === 'errorsServerTooHigh' ||
                    errorMessage === 'errorsServerTooHighMultiRate') && (react_1.default.createElement(Copy, { copyKey: "validationPromptErrorNotificationTitleTooHigh" })),
                (errorMessage === 'errorsServerTooLow' ||
                    errorMessage === 'errorsServerTooLowMultiRate') && (react_1.default.createElement(Copy, { copyKey: "validationPromptErrorNotificationTitleTooLow" })),
                errorMessage === 'errorsFallback' && (react_1.default.createElement(Copy, { copyKey: "validationPromptErrorNotificationTitleFallback" }))),
            react_1.default.createElement(Copy, { copyKey: errorMessage }),
            react_1.default.createElement(Copy, { copyKey: "validationPromptCheckInfo" }),
            react_1.default.createElement(core_1.Feature, { feature: "meterPhoto" }, function (enabled) {
                return enabled ? react_1.default.createElement(Copy, { copyKey: "validationPromptErrorAddPhoto" }) : null;
            })),
        react_1.default.createElement(SummaryList, null,
            previousReading && (react_1.default.createElement(SummaryItem, { label: react_1.default.createElement(Copy, { copyKey: "validationPromptLastReadingDate", values: {
                        lastReadingDate: "".concat(previousReading ? previousReading.dateString : ''),
                        readingType: apiErrorData &&
                            (0, utils_2.isEstimatedReadingType)(apiErrorData[0].invalidAgainst.readingType)
                            ? 'estimated'
                            : 'manual',
                    } }) }, (apiErrorData &&
                apiErrorData[0].errorCode === 'LOWER_THAN_PREVIOUS_READING') ||
                (apiErrorData &&
                    apiErrorData[0].errorCode === 'CONSUMPTION_TOO_HIGH') ? (react_1.default.createElement(Reading, { value: ((_b = formatPreviousReading(apiErrorData[0].invalidAgainst)) === null || _b === void 0 ? void 0 : _b.value) || previousReading.value, numOfDigits: numOfDigits, isError: false })) : (react_1.default.createElement(Reading, { value: previousReading.value, numOfDigits: numOfDigits, isError: false })))),
            react_1.default.createElement(SummaryItem, { label: react_1.default.createElement(Copy, { copyKey: "validationPromptReadingYouEntered" }) },
                react_1.default.createElement(Reading, { value: reading, numOfDigits: numOfDigits, isError: true }))),
        react_1.default.createElement(core_1.Feature, { feature: "meterPhoto" }, function (enabled) {
            var _a, _b, _c, _d;
            return enabled ? (react_1.default.createElement(Stack, { spaceBetween: 4 },
                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.METER_READ_VALIDATION_CHANGE_READ, properties: (_a = {},
                        _a[core_1.INTERNAL_EVENT_FLAG] = true,
                        _a) },
                    react_1.default.createElement(PrimaryCTAButton, { onClick: onCancel },
                        react_1.default.createElement(MeterReadingValidationPrompt_styled_1.StyledEdit, null,
                            react_1.default.createElement(images_1.EditIcon, null)),
                        react_1.default.createElement(Copy, { copyKey: "validationPromptChange" }))),
                react_1.default.createElement(AddMeterPhoto_1.AddMeterPhoto, { onImageChange: handleImageChange }),
                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.METER_READ_VALIDATION_SUBMIT_READ, properties: (_b = {},
                        _b[core_1.INTERNAL_EVENT_FLAG] = true,
                        _b) },
                    react_1.default.createElement(SecondaryCTAButton, { loading: isLoading, onClick: handleSubmit, type: "submit", disabled: isInProgress },
                        react_1.default.createElement(Copy, { copyKey: "validationPromptSubmit", values: { fuel: fuel } }))))) : (react_1.default.createElement(ButtonGroup, null,
                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.METER_READ_VALIDATION_CHANGE_READ, properties: (_c = {},
                        _c[core_1.INTERNAL_EVENT_FLAG] = true,
                        _c) },
                    react_1.default.createElement(PrimaryCTAButton, { onClick: onCancel },
                        react_1.default.createElement(MeterReadingValidationPrompt_styled_1.StyledEdit, null,
                            react_1.default.createElement(images_1.EditIcon, null)),
                        react_1.default.createElement(Copy, { copyKey: "validationPromptChange" }))),
                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.METER_READ_VALIDATION_SUBMIT_READ, properties: (_d = {},
                        _d[core_1.INTERNAL_EVENT_FLAG] = true,
                        _d) },
                    react_1.default.createElement(SecondaryCTAButton, { loading: isLoading, onClick: handleSubmit, type: "submit", disabled: isInProgress },
                        react_1.default.createElement(Copy, { copyKey: "validationPromptSubmit", values: { fuel: fuel } })))));
        })));
}
exports.MeterReadingValidationPrompt = MeterReadingValidationPrompt;
function getReadingByTimeOfUseLabel(meterReading, timeOfUseLabel) {
    if (!meterReading.hasOwnProperty('tiers')) {
        return null;
    }
    var tier = meterReading.tiers.find(function (tier) { return tier.timeOfUseLabel === timeOfUseLabel; });
    return tier ? tier.meterRegisterReading : null;
}
function formatReading(data, isMultiRate) {
    var _a, _b;
    if ('gasVolume' in data) {
        return data.gasVolume;
    }
    if (isMultiRate) {
        var tiers = data.tiers;
        var peak = (_a = tiers.find(function (_a) {
            var timeOfUseLabel = _a.timeOfUseLabel;
            return timeOfUseLabel === 'peak';
        })) === null || _a === void 0 ? void 0 : _a.meterRegisterReading;
        var offPeak = (_b = tiers.find(function (_a) {
            var timeOfUseLabel = _a.timeOfUseLabel;
            return timeOfUseLabel === 'offpeak';
        })) === null || _b === void 0 ? void 0 : _b.meterRegisterReading;
        if (!peak || !offPeak) {
            throw new Error('Unable to find peak or offPeak readings');
        }
        return { peak: peak, offPeak: offPeak };
    }
    return data.tiers[0].meterRegisterReading;
}
function formatPreviousReading(lastActualReading) {
    if (!lastActualReading) {
        return undefined;
    }
    var isEstimated = (0, utils_2.getReadingTypeLabel)(lastActualReading.readingType) ===
        'Estimated';
    var formattedDate = (isEstimated ? 'Estimated on ' : '') +
        (0, date_fns_1.format)(lastActualReading.readingDateTime, 'd MMM');
    if ('gasVolume' in lastActualReading) {
        var gasVolume = lastActualReading.gasVolume;
        return gasVolume
            ? { dateString: formattedDate, value: gasVolume }
            : undefined;
    }
    var anytimeReading = getReadingByTimeOfUseLabel(lastActualReading, 'anytime');
    var peakReading = getReadingByTimeOfUseLabel(lastActualReading, 'peak');
    var offPeakReading = getReadingByTimeOfUseLabel(lastActualReading, 'offpeak');
    if (peakReading && offPeakReading) {
        return {
            dateString: formattedDate,
            value: { peak: peakReading, offPeak: offPeakReading },
        };
    }
    if (anytimeReading) {
        return { dateString: formattedDate, value: anytimeReading };
    }
    return undefined;
}
function Reading(_a) {
    var value = _a.value, numOfDigits = _a.numOfDigits, isError = _a.isError;
    var Icon = (0, core_1.useComponents)().Icon;
    var colors = (0, react_1.useContext)(styled_components_1.ThemeContext).colors;
    var displayValue = function (reading) {
        return (0, utils_2.applyLeadingZeros)(numOfDigits, reading);
    };
    if (typeof value === 'number') {
        return (react_1.default.createElement(MeterReadingValidationPrompt_styled_1.StyledReading, { isError: isError }, displayValue(value)));
    }
    var iconProps = { color: colors.body, size: 18 };
    return (react_1.default.createElement(MeterReadingValidationPrompt_styled_1.InlineIcons, null,
        react_1.default.createElement(MeterReadingValidationPrompt_styled_1.StyledReading, { isError: isError },
            react_1.default.createElement(Icon, __assign({}, iconProps, { name: "offpeakLegacy" })),
            displayValue(value.offPeak)),
        react_1.default.createElement(MeterReadingValidationPrompt_styled_1.StyledReading, { isError: isError },
            react_1.default.createElement(Icon, __assign({}, iconProps, { name: "peakLegacy" })),
            displayValue(value.peak))));
}
